module.exports = "<listado-general \r\n  [listado]=\"comandos\" \r\n  [titulo]=\"'CONSULTA_SIMPLE' | translate\"\r\n  [urladicional]=\"''\"\r\n  [modoIconosOn]=\"true\"\r\n  (clickNuevo)=\"navegarANuevaConsultaSimple()\"\r\n  [leyendaListado]=\"'DEFAULT_LEYENDA_HOME' | translate\">\r\n</listado-general>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/consultaSimple/listado.consulta.simple.component.html
// module id = ../../../../../src/app/private/consultaSimple/listado.consulta.simple.component.html
// module chunks = main